/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9302a31b (Tue Nov  3 17:38:29 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  PaginationResponse,
  PaginationResponseFromJSON,
  PaginationResponseToJSON,
  PotentialInviteItem,
  PotentialInviteItemFromJSON,
  PotentialInviteItemToJSON,
} from './'

/**
 *
 * @export
 * @interface FetchPotentialInvitesResponse
 */
export interface FetchPotentialInvitesResponse {
  /**
   *
   * @type {Array<PotentialInviteItem>}
   * @memberof FetchPotentialInvitesResponse
   */
  potentialInvites: Array<PotentialInviteItem>
  /**
   *
   * @type PaginationResponse
   * @memberof FetchPotentialInvitesResponse
   */
  pagination?: PaginationResponse
  /**
   * Total number of potential invites with source ReturningFamily (unaffected by pagination).
   * @type number
   * @memberof FetchPotentialInvitesResponse
   */
  returningFamilyCount?: number
  /**
   * Total number of potential invites with source LCDReferral (unaffected by pagination).
   * @type number
   * @memberof FetchPotentialInvitesResponse
   */
  lcdReferralCount?: number
}

export function FetchPotentialInvitesResponseFromJSON(
  json: any
): FetchPotentialInvitesResponse {
  return FetchPotentialInvitesResponseFromJSONTyped(json, false)
}

export function FetchPotentialInvitesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchPotentialInvitesResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    potentialInvites: (json['potentialInvites'] as Array<any>).map(
      PotentialInviteItemFromJSON
    ),
    pagination: !exists(json, 'pagination')
      ? undefined
      : PaginationResponseFromJSON(json['pagination']),
    returningFamilyCount: !exists(json, 'returningFamilyCount')
      ? undefined
      : json['returningFamilyCount'],
    lcdReferralCount: !exists(json, 'lcdReferralCount')
      ? undefined
      : json['lcdReferralCount'],
  }
}

export function FetchPotentialInvitesResponseToJSON(
  value?: FetchPotentialInvitesResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    potentialInvites: (value.potentialInvites as Array<any>).map(
      PotentialInviteItemToJSON
    ),
    pagination: PaginationResponseToJSON(value.pagination),
    returningFamilyCount: value.returningFamilyCount,
    lcdReferralCount: value.lcdReferralCount,
  }
}
